import { Box, Divider, Typography } from '@mui/material';
import { rootSx } from './style';

export default function GenerativeGuideContent() {
  return (
    <Box className="GenerativeGuideContent-root" sx={rootSx}>
      <Box className="GenerativeGuideContent-main">
        <Typography className="GenerativeGuideContent-title">생성모델 설명</Typography>
        <Typography className="GenerativeGuideContent-subtitle">
          주어진 데이터를 학습하여 새로운 데이터를 생성하는 인공지능 모델
        </Typography>
      </Box>

      <Box className="GenerativeGuideContent-section">
        <Box className="GenerativeGuideContent-imageBox">
          <img src="/_static/images/generative_1.png" width="100%" alt="" />
        </Box>
        <Typography>
          <b>생성 모델(Ganerative model)</b>은 정답(Label) 혹은 임의의 변수(Variable)로 부터 Data 를
          생성하는 기법 입니다.
          <br />
          쉽게 말해, 생성 모델은 주어진 데이터로 학습한 내용을 바탕으로 새로운 정보나 컨텐츠를
          생성할 수 있는 능력을 가지고 있습니다.
          <br />
          <br />
          예를 들어, 여러분이 그림을 그리는 걸 상상해 보세요. 생성모델은 그림 그리기를 잘하는
          친구라고 생각할 수 있습니다. 이 친구는 다양한 그림을 보고 학습한 뒤, 여러분이 원하는
          스타일이나 주제에 맞는 새로운 그림을 그릴 수 있습니다.
        </Typography>
      </Box>

      <Divider />
      <Box className="GenerativeGuideContent-section">
        <Box className="GenerativeGuideContent-title">초거대 언어 모델</Box>
        <Typography>
          <em>초거대 언어 모델</em>은 매우 큰 규모의 인공지능 모델입니다.
          <br />
          초거대 언어 모델은 엄청나게 많은 양의 글을 읽고 학습하며 작동합니다.
          <br />
          이 과정에서 글의 구조, 단어의 사용 방법, 문장 간의 관계 등을 배웁니다.
          <br />
          <br />
          이렇게 배운 내용을 바탕으로 새로운 글이나 이야기를 만들어 낼 수 있고, 사람이 하는 질문에
          답변을 제공하기도 합니다.
          <br />
          또한 한 언어로 된 글을 다른 언어로 번역하는 것도 가능합니다.
          <Box className="GenerativeGuideContent-imageBox">
            <img src="/_static/images/generative_2.png" width={300} alt="" />
          </Box>
        </Typography>
        <Box className="GenerativeGuideContent-title">애니메이션 변환</Box>
        <Typography>
          <b>애니메이션 변환</b>이란 웹캠으로 촬영한 사진이나 이미지를 <em>GAN</em>기술을 통해
          애니메이션으로 바꿔주는 기법입니다.
          <br />
          여기서 <em>GAN(Generative Adversarial Network)</em> 기술이란
          <em> 두 개의 똑똑한 컴퓨터</em>가 서로 겨루면서 뭔가 새로운 것을 만들어내는 것을 말합니다.
          <br />
          <br />
          예를 들어, <b>제작자</b>라는 컴퓨터와 <b>감별자</b>라는 컴퓨터가 있습니다.
          <br />
          <b>제작자</b>는 평범한 사진이나 이미지를 보고, 애니메이션 스타일로 바꾸려고 노력합니다.{' '}
          <b>감별자</b>는 제작자가 바꾼 애니메이션 그림을 보고 이 그림이 진짜 애니메이션 같은지
          판단합니다.
          <br />
          <br />
          <b>감별자</b>가 그림을 보고 &quot;이건 애니메이션 같지 않아!&quot; 라고 말하면,{' '}
          <b>제작자</b>는 그 피드백을 듣고 그림을 더 잘 그리려고 노력합니다.
          <br />
          <b>감별자</b>는 점점 더 똑똑해져서 제작자가 만든 그림을 더 정확하게 평가할 수 있게 됩니다.
          <br />
          <br />
          이렇게 두 컴퓨터가 서로 경쟁하면서, <b>제작자</b>는 점점 더 멋진 애니메이션 그림을 만들게
          되고, <b>감별자</b>는 그림을 잘 평가할 수 있게 됩니다.
          <br /> 결과적으로, GAN 기술 덕분에 평범한 사진과 이미지가 멋진 애니메이션으로 변환됩니다.
          <Box className="GenerativeGuideContent-imageBox">
            <img src="/_static/images/generative_3.png" width={300} alt="" />
          </Box>
        </Typography>
        <Box className="GenerativeGuideContent-title">화풍 변환</Box>
        <Typography>
          <em>화풍변환(Style Transfer)</em>은 생성모델의 한 종류로, 이미지의 스타일을 다른 이미지에
          적용하는 기술입니다.
          <br />이 기술은 기본적으로 두 가지 이미지를 입력받아 하나의 이미지에서 스타일을 추출하고,
          다른 이미지에 그 스타일을 적용하여 새로운 이미지를 생성하는 방식으로 작동합니다.
          <Box className="GenerativeGuideContent-imageBox">
            <img src="/_static/images/generative_4.png" width={300} alt="" />
          </Box>
        </Typography>
      </Box>
    </Box>
  );
}
